import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Features } from './pages/Features';
import { Vision } from './pages/Vision';
import { Integrations } from './pages/Integrations';
import { Pricing } from './pages/Pricing';
export function AppRouter() {
  return <BrowserRouter data-id="element-10">
      <Routes data-id="element-11">
        <Route path="/" element={<App data-id="element-13" />} data-id="element-12" />
        <Route path="/features" element={<Features data-id="element-15" />} data-id="element-14" />
        <Route path="/vision" element={<Vision data-id="element-17" />} data-id="element-16" />
        <Route path="/integrations" element={<Integrations data-id="element-19" />} data-id="element-18" />
        <Route path="/pricing" element={<Pricing data-id="element-21" />} data-id="element-20" />
      </Routes>
    </BrowserRouter>;
}